import React from 'react';

const SECTIONS = [
  { id: 'contact', label: 'Contact' },
  { id: 'content', label: 'Content' },
  { id: 'home-sections', label: 'Home sections' },
  { id: 'seo', label: 'SEO' },
  { id: 'featured', label: 'Featured' },
  { id: 'articles', label: 'Gift & styling' },
  { id: 'policies', label: 'Policies' },
  { id: 'auth', label: 'Sign-in' },
  { id: 'shop', label: 'Shop & trust' },
  { id: 'checkout', label: 'Checkout' },
  { id: 'shipping-labels', label: 'Shipping labels' },
  { id: 'email', label: 'Email' },
];

const STANDALONE_SAVE = new Set(['checkout', 'shipping-labels', 'email']);

export function AdminSiteSubnav({ active, onChange, saving, onReload, onSaveSection }) {
  const standalone = STANDALONE_SAVE.has(active);

  return (
    <div className="admin-site-subnav">
      <div className="admin-site-subnav__head">
        <span className="admin-site-subnav__title">Site settings</span>
        <div className="admin-site-subnav__actions">
          <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onReload} disabled={saving}>
            Reload
          </button>
          {!standalone ? (
            <button type="button" className="btn btn-primary btn-sm" onClick={onSaveSection} disabled={saving}>
              {saving ? 'Saving…' : 'Save'}
            </button>
          ) : (
            <span className="admin-site-subnav__save-hint small text-muted">Save on page below</span>
          )}
        </div>
      </div>
      <div className="admin-site-subnav__scroll" role="tablist" aria-label="Site settings sections">
        {SECTIONS.map((s) => (
          <button
            key={s.id}
            type="button"
            role="tab"
            aria-selected={active === s.id}
            className={`admin-site-subnav__tab${active === s.id ? ' admin-site-subnav__tab--active' : ''}`}
            onClick={() => onChange(s.id)}
          >
            {s.label}
          </button>
        ))}
      </div>
    </div>
  );
}

/** @deprecated use AdminSiteSubnav */
export default function AdminSiteSectionNav({ active, onChange }) {
  return (
    <div className="admin-site-subnav__scroll only-tabs" role="tablist" aria-label="Site settings sections">
      {SECTIONS.map((s) => (
        <button
          key={s.id}
          type="button"
          role="tab"
          aria-selected={active === s.id}
          className={`admin-site-subnav__tab${active === s.id ? ' admin-site-subnav__tab--active' : ''}`}
          onClick={() => onChange(s.id)}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
